import React from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";

export default function MobileStickyCTA({ onRequestDemo }) {
  const { t } = useI18n();
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-md border-t border-slate-200 px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-[0_-6px_20px_-5px_rgba(15,23,42,0.08)]"
    >
      <Button
        data-testid="mobile-sticky-request-demo-btn"
        onClick={onRequestDemo}
        className="w-full h-12 bg-[#6B46C1] hover:bg-[#553C9A] text-white font-semibold text-base rounded-lg shadow-md shadow-purple-300/40"
      >
        {t("stickyCta")}
      </Button>
    </div>
  );
}
